import { render, staticRenderFns } from "./teamDetail1info.vue?vue&type=template&id=6bb94ef2&scoped=true&"
import script from "./teamDetail1info.vue?vue&type=script&lang=js&"
export * from "./teamDetail1info.vue?vue&type=script&lang=js&"
import style0 from "./teamDetail1info.vue?vue&type=style&index=0&id=6bb94ef2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb94ef2",
  null
  
)

export default component.exports